import { digObject } from '@domain-group/javascript-utils'

import { useLatestEntity } from '@domain-group/react-hooks'

import type { OrderItemTaskTypeModel } from '@models/types'

type GenerateUrlsOptions = {
  prefixRoute?: string,
}
export const generateUrls = (options: GenerateUrlsOptions = {}) => {
  const { prefixRoute = 'systemManager' } = options || {}

  return {
    taskPricingIndexUrl: `#/${prefixRoute}/taskPricing`,
  }
}

function useOrderItemTaskType(initEntity: Partial<OrderItemTaskTypeModel> = {}) {
  // @ts-expect-error TS2322
  const { entity: orderItemTaskType }:
    // @ts-expect-error TS2345
    { entity: OrderItemTaskTypeModel } = useLatestEntity(initEntity, 'orderItemTaskTypes')

  const taskColor = digObject(orderItemTaskType, 'options.color', '8c8c8e')

  return {
    orderItemTaskType,
    taskColor,
  }
}

export default useOrderItemTaskType
